import React from 'react'
import { getCanvasSafeCoverSrc } from '../../Utils'
import {
	Box,
	Heading,
	Text,
	Image,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	Badge,
	Wrap,
	WrapItem,
	useColorModeValue,
} from '@chakra-ui/react'

import { TIER_META } from '../../ranking/rankingState'

function tierGamesOrdered(tierKey, rankState, itemsById) {
	const ids = rankState?.tiers?.[tierKey] || []
	return ids.map((id) => itemsById[id]).filter(Boolean)
}

const Step3 = React.forwardRef(function Step3(props, ref) {
	const { rankState, itemsById } = props
	const cellBg = useColorModeValue('gray.50', 'bgg.900')
	const bodyMuted = useColorModeValue('gray.600', 'bgg.muted')
	const poolIds = rankState?.pool || []
	const excludedIds = rankState?.excluded || []

	return (
		<Box>
			<Heading as="h3" size="lg" mb={2}>
				Step 3: Your tiers
			</Heading>
			<Text color={bodyMuted} mb={6} fontSize="sm">
				Overview of your ranking. Thumbnails wrap on smaller screens.
			</Text>
			<Box
				ref={ref}
				overflowX="auto"
				rounded="xl"
				borderWidth="1px"
				borderColor="blackAlpha.50"
				_dark={{ borderColor: 'whiteAlpha.300' }}
			>
				<Table variant="simple" size="sm">
					<Thead>
						<Tr>
							<Th w="72px">Tier</Th>
							<Th>Games</Th>
						</Tr>
					</Thead>
					<Tbody>
						{poolIds.length > 0 ? (
							<Tr>
								<Td verticalAlign="top" bg={cellBg}>
									<Badge colorScheme="gray" fontSize="0.85em" px={2} py={0.5} rounded="md">
										Unsorted
									</Badge>
								</Td>
								<Td>
									<Wrap spacing={2} shouldWrapChildren>
										{poolIds.map((id) => {
											const g = itemsById[id]
											if (!g) return null
											return (
												<WrapItem key={id}>
													<Image
														crossOrigin="anonymous"
														src={getCanvasSafeCoverSrc(g)}
														alt=""
														h="64px"
														w="64px"
														rounded="md"
														objectFit="cover"
														bg="gray.100"
														borderWidth="1px"
														borderColor="blackAlpha.50"
														_dark={{ borderColor: 'whiteAlpha.300' }}
													/>
												</WrapItem>
											)
										})}
									</Wrap>
								</Td>
							</Tr>
						) : null}
						{TIER_META.map(({ key, label, colorScheme }) => {
							const games = tierGamesOrdered(key, rankState, itemsById)
							return (
								<Tr key={key}>
									<Td verticalAlign="top" bg={cellBg}>
										<Badge colorScheme={colorScheme} fontSize="0.85em" px={2} py={0.5} rounded="md">
											{label}
										</Badge>
									</Td>
									<Td>
										{games.length === 0 ? (
											<Text fontSize="sm" color="gray.500">
												—
											</Text>
										) : (
											<Wrap spacing={2} shouldWrapChildren>
												{games.map((g) => (
													<WrapItem key={g.objectid || g.name}>
														<Image
															crossOrigin="anonymous"
															src={getCanvasSafeCoverSrc(g)}
															alt=""
															h="64px"
															w="64px"
															rounded="md"
															objectFit="cover"
															bg="gray.100"
															borderWidth="1px"
															borderColor="blackAlpha.50"
															_dark={{ borderColor: 'whiteAlpha.300' }}
														/>
													</WrapItem>
												))}
											</Wrap>
										)}
									</Td>
								</Tr>
							)
						})}
						{excludedIds.length > 0 ? (
							<Tr>
								<Td verticalAlign="top" bg={cellBg}>
									<Badge colorScheme="gray" fontSize="0.85em" px={2} py={0.5} rounded="md">
										Excluded
									</Badge>
								</Td>
								<Td>
									<Wrap spacing={2} shouldWrapChildren>
										{excludedIds.map((id) => {
											const g = itemsById[id]
											if (!g) return null
											return (
												<WrapItem key={id}>
													<Image
														crossOrigin="anonymous"
														src={getCanvasSafeCoverSrc(g)}
														alt=""
														h="64px"
														w="64px"
														rounded="md"
														objectFit="cover"
														bg="gray.100"
														opacity={0.65}
														borderWidth="1px"
														borderColor="blackAlpha.50"
														_dark={{ borderColor: 'whiteAlpha.300' }}
													/>
												</WrapItem>
											)
										})}
									</Wrap>
								</Td>
							</Tr>
						) : null}
					</Tbody>
				</Table>
			</Box>
		</Box>
	)
})

export default Step3
